import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=f61641ac&scoped=true&"
import script from "./CustomerList.vue?vue&type=script&lang=js&"
export * from "./CustomerList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CustomerList.vue?vue&type=style&index=1&id=f61641ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61641ac",
  null
  
)

export default component.exports